<template>
    <div>
    <!-- :ref="modalRef" -->
        <b-modal :title="modalTitle" ref="modal-Ref" hide-footer :size="modalSize" :class="modalExtraClass">
            <b-row v-for="(field, index) in fields" :key="index" class="mb-2">
                <b-col md="3">
                <label>{{ field.label }} <span v-if="field.required" class="text-danger">*</span></label>
        
                <b-form-input
                    v-if="field.fieldType === 'input'"
                    v-model="formModel[field.key]"
                    :disabled="field.disabled"
                    :placeholder="field.placeholder || ''"
                    size="sm"
                />
        
                <b-form-textarea
                    v-if="field.fieldType === 'textarea'"
                    v-model="formModel[field.key]"
                    :rows="field.rows || 3"
                    :disabled="field.disabled"
                    :placeholder="field.placeholder || ''"
                />
        
                <b-form-datepicker
                    v-if="field.fieldType === 'datepicker'"
                    v-model="formModel[field.key]"
                    :disabled="field.disabled"
                    :placeholder="field.placeholder || 'Select date'"
                />
        
                <model-list-select
                    v-if="field.fieldType === 'single-select'"
                    :disabled="field.disabled"
                    :list="$store.getters[field.storeGetter]"
                    v-model="formModel[field.key]"
                    :option-value="field.optionValue"
                    :option-text="field.optionText"
                    :placeholder="field.placeholder || 'Select'"
                />
        
                <multi-select
                    v-if="field.fieldType === 'multi-select'"
                    :disabled="field.disabled"
                    :options="$store.getters[field.storeGetter]"
                    v-model="formModel[field.key]"
                    :placeholder="field.placeholder || 'Select multiple'"
                    :multiple="true"
                />
        
                <b-form-radio-group
                    v-if="field.fieldType === 'radio-group'"
                    v-model="formModel[field.key]"
                    :options="$store.getters[field.optionList]"
                    :value-field="field.valueField"
                    :text-field="field.textField"
                    :disabled-field="field.disabledField"
                    class="mt-2"
                />
        
                </b-col>
            </b-row>
        
            <b-row>
                <b-col class="text-center my-2">
                <b-button variant="primary" size="sm" @click="$emit('save', formModel)">Save</b-button>
                <b-button variant="danger" size="sm" class="ml-2" @click="hideDynamicModal">Close</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
  
<script>
    import { DateFormat, selectDateFormat } from "../../helper/filters";
    import Multiselect from "vue-multiselect";
    import { ModelListSelect, MultiSelect } from "vue-search-select";
    import DatePicker from "vue2-datepicker";
    export default {
        props: {
            modalRef: String,
            modalTitle: String,
            fields: Array,
            modelValue: Object,
            modalSize: String,
            modalExtraClass: String,
        },
        components: {
            ModelListSelect,
            MultiSelect,
            Multiselect,
            DatePicker,
        },
        computed: {
            formModel: {
                get() {
                    console.log(this.modelValue);
                    return this.modelValue;
                },
                set(val) {
                    this.$emit('update:modelValue', val);
                }
            }
        },
        methods: {
            showDynamicModal() {
                this.$refs['modal-Ref'].show();
            },
            hideDynamicModal() {
                this.$refs['modal-Ref'].hide();
            }

        }
    };
</script>

  
<style>
    .w-90 .modal-dialog {
        max-width: 90% !important;
        margin: 0 auto !important;
    }
</style>


// WEBPACK FOOTER //
// DynamicModal.vue?aeda174a